<template>
    <div component="Doc">
        <div class="content">
            <section class="header">
                <h1>MP3 PLAYER</h1>
                <div class="desc" contenteditable="true">&ltmp3-player :file="Actor.mp3" :text="'Sample 1'"/></div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>Attributes</h2>
                </div>
                <div class="content">
                    <div class="demo">
                        <div class="desc" contenteditable="">size="big"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :size="'big'"
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">size="small"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :size="'small'"
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">tpos="none"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :tpos="'none'"
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">tpos="top"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :tpos="'top'"
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">tpos="left"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :tpos="'left'"
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">tpos="right"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :tpos="'right'"
                            size="big"
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">loading=""</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :size="'big'"
                            loading
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">playing=""</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :size="'big'"
                            playing
                        ></mp3-player>
                    </div>
                    <div class="demo">
                        <div class="desc" contenteditable="">state="error"</div>
                        <mp3-player
                            :file="'http://www.voicecasting.sk/preview.php?id=cdb48dc024ca2f68fd65b3ef4bcd3bed'"
                            :text="'Sample 1'"
                            :size="'big'"
                            :state="'error'"
                        ></mp3-player>
                    </div>
                    <visualizer name="voice" />
                </div>
            </section>
            <section class="header">
                <h1>BUTTON</h1>
                <div class="desc" contenteditable="true">
                    &ltnav-button :link="'/'" :text="'Homepage'" :icon="'home'"/>
                </div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>:icon</h2>
                </div>
                <div class="content">
                    <div class="demo" v-for="button in icons" :key="button.link">
                        <div class="desc" contenteditable="">icon="{{ button.icon }}"</div>
                        <nav-button :link="'#'" :icon="button.icon" :text="'Button'"></nav-button>
                    </div>
                </div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>:size</h2>
                </div>
                <div class="content">
                    <div class="demo" v-for="button in sizes" :key="button.link">
                        <div class="desc" contenteditable="">size="{{ button.size }}"</div>
                        <nav-button :link="'#'" :icon="'camera_alt'" :text="'Button'" :size="button.size"></nav-button>
                    </div>
                </div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>:color</h2>
                </div>
                <div class="content">
                    <div class="demo" v-for="button in colors" :key="button.link">
                        <div class="desc" contenteditable="">color="{{ button.color }}"</div>
                        <nav-button :link="'#'" :icon="'share'" :text="'Button'" :color="button.color"></nav-button>
                    </div>
                </div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>:tpos</h2>
                </div>
                <div class="content">
                    <div class="demo" v-for="button in tposes" :key="button.link">
                        <div class="desc" contenteditable="">tpos="{{ button.tpos }}"</div>
                        <nav-button
                            :link="'#'"
                            :icon="'volume_up'"
                            :text="'Button'"
                            :size="button.size"
                            :radius="button.radius"
                            :tpos="button.tpos"
                        ></nav-button>
                    </div>
                </div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>:radius</h2>
                </div>
                <div class="content">
                    <div class="demo" v-for="button in radiuses" :key="button.link">
                        <div class="desc" contenteditable="">radius="{{ button.radius }}"</div>
                        <nav-button :link="'#'" :icon="'share'" :text="'Button'" :radius="button.radius"></nav-button>
                    </div>
                </div>
            </section>
            <section class="body">
                <div class="name">
                    <h2>:state</h2>
                </div>
                <div class="content">
                    <div class="demo" v-for="button in states" :key="button.link">
                        <div class="desc" contenteditable="">state="{{ button.state }}"</div>
                        <nav-button
                            :link="'#'"
                            :icon="'power_settings_new'"
                            :text="'Button'"
                            :state="button.state"
                        ></nav-button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player.vue';

export default {
    name: 'ButtonsDoc',

    mounted() {},

    methods: {},

    data() {
        return {
            icons: [
                {
                    icon: 'share',
                },
                {
                    icon: 'volume_up',
                },
                {
                    icon: 'camera_alt',
                },
            ],

            sizes: [
                {
                    size: '',
                },
                {
                    size: 'big',
                },
                {
                    size: 'icon',
                },
                {
                    size: 'fullwidth',
                },
            ],

            colors: [
                {
                    color: '',
                },
                {
                    color: 'primary',
                },
                {
                    color: 'accent',
                },
                {
                    color: 'ghost',
                },
                {
                    color: 'transparent',
                },
            ],

            tposes: [
                {
                    size: 'big',
                },
                {
                    size: 'big',
                    tpos: 'left',
                },
                {
                    radius: 'circle',
                    size: 'big',
                    tpos: 'top',
                },
                {
                    radius: 'circle',
                    size: 'big',
                    tpos: 'bottom',
                },

                {
                    size: 'big',
                    tpos: 'none',
                },
                {
                    size: 'big',
                    tpos: 'none',
                },
            ],

            radiuses: [
                {
                    radius: 'none',
                },
                {
                    radius: 'small',
                },
                {
                    radius: 'big',
                },
                {
                    radius: 'circle',
                },
            ],

            states: [
                {
                    state: 'disabled',
                },
                {
                    state: 'load',
                },
                {
                    state: 'progress',
                },
                {
                    state: 'success',
                },
                {
                    state: 'error',
                },
                {
                    state: 'warning',
                },
            ],
        };
    },

    components: {
        Mp3Player,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';
</style>
